import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Link,
  IconButton,
  Button,
  Tooltip,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { MEDIA_URL } from "../../../api/endpoints";
import { useDispatch } from "react-redux";
import { updateResumeDownloadLimit } from "../../../features/Recruiter/candidateSlice";
import { notifyError } from "../../../utils/notificationMsg";
import { NavLink, useNavigate } from "react-router-dom";
import { SectionContainer } from "../../../components/Profile/EditProfile";
import { Box } from "@mui/system";
import { formatAmount } from "../../../utils/helpers";
import { updateShortlistedCandidates } from "../../../features/Client/ShortListCandidate";

export const ResumeActionLink = ({
  row,
  handleAction,
  dispatch,
  clientId,
  searchLogId,
}) => {
  const isDownloaded = row?.downloadinfo?.find(
    (client) => client?.clientid?.$oid === clientId
  )?.isdownloaded;

  return (
    <Button
      variant="text"
      size="small"
      color={isDownloaded ? "secondary" : "error"}
      underline="none"
      sx={{
        fontWeight: "bold",
        // border: `1px solid ${isDownloaded ? "green" : "red"}`,
        border: `1px solid red`,
        borderRadius: "4px",
        "&:hover": {
          // border: `1px solid ${isDownloaded ? "darkgreen" : "darkred"}`,
          border: `1px solid darkred`,
        },
        mx: 1,
      }}
      onClick={(event) =>
        handleAction(row, event, dispatch, clientId, searchLogId)
      }
    >
      <Tooltip title={"Download"} arrow>
        {/* {isDownloaded ? <VisibilityIcon /> : <DownloadIcon />} */}
        <DownloadIcon sx={{ color: "red" }} />
      </Tooltip>
    </Button>
  );
};

export const handleResumeAction = async (
  row,
  event,
  dispatch,
  clientId,
  searchLogId
) => {
  event.stopPropagation();
  const isDownloaded = row?.downloadinfo?.find(
    (client) => client?.clientid?.$oid === clientId
  )?.isdownloaded;
  if (isDownloaded) {
    window.open(`${MEDIA_URL}${row.candidate_resumeurl}`, "_blank");
  } else {
    const data = {
      candidateid: row._id?.$oid,
      clientid: clientId,
      isdownloaded: isDownloaded ? isDownloaded : false,
      searchlogid: searchLogId,
    };
    const { payload } = await dispatch(updateResumeDownloadLimit(data));
    if (payload.status === 200) {
      if (payload?.status === 200) {
        dispatch(
          updateShortlistedCandidates({
            candidateid: row._id?.$oid,
            message: payload?.message,
          })
        );
      }
      window.open(`${MEDIA_URL}${row.candidate_resumeurl}`, "_blank");
    } else {
      notifyError(payload.details);
    }
  }
};

export const handleResumeAction2 = async (row, event, dispatch, clientId) => {
  event.stopPropagation();
  window.open(`${MEDIA_URL}${row}`, "_blank");
};

const ProfileRecordTable = ({
  candidateData,
  clientId,
  searchLogId,
  search_id,
}) => {
  const dispatch = useDispatch();

  return (
    <TableContainer
      component={Paper}
      sx={{ maxWidth: 1200, margin: "auto", marginTop: 2 }}
    >
      <Typography
        variant="h6"
        sx={{
          padding: "16px",
          fontWeight: 600,
          fontFamily: "Urbane-Light",
          fontSize: "14px",
        }}
      >
        Profile Record
      </Typography>
      {Array.isArray(candidateData) ? (
        <Table sx={{ border: "1px solid #ddd", borderCollapse: "collapse" }}>
          <TableHead sx={{ background: "#ECF1FF" }}>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  fontSize: "12px",
                  textAlign: "center",
                  border: "1px solid #ddd",
                }}
              >
                Name
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  fontSize: "12px",
                  textAlign: "center",
                  border: "1px solid #ddd",
                }}
              >
                Preferred Location
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  fontSize: "12px",
                  textAlign: "center",
                  border: "1px solid #ddd",
                }}
              >
                Job Title
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  fontSize: "12px",
                  textAlign: "center",
                  border: "1px solid #ddd",
                }}
              >
                Expertise
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  fontSize: "12px",
                  textAlign: "center",
                  border: "1px solid #ddd",
                }}
              >
                No. of Year Experiance
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  fontSize: "12px",
                  textAlign: "center",
                  border: "1px solid #ddd",
                }}
              >
                Expected Compensation Range
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  fontSize: "12px",
                  textAlign: "center",
                  border: "1px solid #ddd",
                }}
              >
                Resume
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "& .MuiTableCell-root": {
                fontSize: "12px",
                border: "1px solid #ddd",
              },
            }}
          >
            {candidateData?.map((row, index) => (
              <TableRow key={index}>
                <TableCell
                  sx={{
                    cursor: "pointer",
                    color: "primary.main",
                    border: "1px solid #ddd",
                  }}
                >
                  <NavLink
                    to={
                      search_id
                        ? `/${"candidate-view-details"}/${
                            row._id.$oid
                          }?search_id=${search_id}`
                        : `/${"candidate-details"}/${
                            row._id.$oid
                          }?search_id=${searchLogId}`
                    }
                  >
                    <Tooltip title="View" arrow>
                      {`${row.candidate_firstname} ${row.candidate_lastname}`}
                    </Tooltip>
                  </NavLink>
                </TableCell>

                <TableCell sx={{ border: "1px solid #ddd" }}>
                  {row.candidate_anylocation === "any"
                    ? "Any Location"
                    : Array.isArray(row.candidate_specifiedlocation) &&
                      row.candidate_specifiedlocation?.map((label, idx) => (
                        <React.Fragment key={idx}>
                          {label}
                          {idx <
                            row.candidate_specifiedlocation?.length - 1 && (
                            <br />
                          )}
                        </React.Fragment>
                      ))}
                </TableCell>
                <TableCell sx={{ border: "1px solid #ddd" }}>
                  {row.candidate_company?.length > 0
                    ? row.candidate_company?.map((job, index) => (
                        <React.Fragment key={index}>
                          {job.job_title}
                          {index < row.candidate_company?.length - 1 && (
                            <span>, </span>
                          )}
                        </React.Fragment>
                      ))
                    : "Currently Not Working"}
                  {/* {row.candidate_company?.some((job) => job.isPresent)
                    ? row.candidate_company?.map((job, index) => (
                        <React.Fragment key={index}>
                          {job.isPresent ? job.job_title : null}
                          {index < row.candidate_company?.length - 1 && (
                            <span>, </span>
                          )}
                        </React.Fragment>
                      ))
                    : "Currently Not Working"} */}
                </TableCell>
                <TableCell sx={{ border: "1px solid #ddd" }}>
                  {Array.isArray(row.candidate_expertise) &&
                    row.candidate_expertise?.map(({ label }, idx) => (
                      <React.Fragment key={idx}>
                        {label}
                        {idx < row.candidate_expertise?.length - 1 && (
                          <span>
                            ,<br />
                          </span>
                        )}
                      </React.Fragment>
                    ))}
                </TableCell>
                <TableCell sx={{ border: "1px solid #ddd" }}>
                  {" "}
                  {row.candidate_experiance}{" "}
                </TableCell>
                <TableCell
                  sx={{ textAlign: "end", border: "1px solid #ddd" }}
                >{`$${formatAmount(
                  row.candidate_compensation_from
                )} - $${formatAmount(
                  row.candidate_compensation_to
                )}`}</TableCell>
                <TableCell sx={{ border: "1px solid #ddd" }}>
                  <ResumeActionLink
                    row={row}
                    handleAction={handleResumeAction}
                    dispatch={dispatch}
                    clientId={clientId}
                    searchLogId={searchLogId}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      ) : (
        <SectionContainer>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            marginBottom={2}
          >
            <Typography variant="body1" sx={{ fontSize: "18px" }}>
              Candidates Profile Not Found !
            </Typography>
          </Box>{" "}
        </SectionContainer>
      )}
    </TableContainer>
  );
};

export default ProfileRecordTable;
